import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../modules/auth/firebaseConfig";

export default function SmartCardBadge({ userId, role }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    getDoc(doc(db, "smartcardData", userId)).then((snap) =>
      setUser(snap.data())
    );
  }, []);

  if (!user) return null;

  return (
    <div className="bg-[#1E4BA3] text-white text-xs px-3 py-2 rounded-md ml-4 mb-2 w-fit">
      <p className="font-bold">{user.name}</p>
      <p>{role}</p>
      <p className="opacity-60">{user.country}</p>
    </div>
  );
}
